// actions.js
export const INIT_COMPANY_ADMIN_LIST_REQUEST = 'INIT_COMPANY_ADMIN_LIST_REQUEST';
export const SET_COMPANY_ADMIN_LIST = 'SET_COMPANY_ADMIN_LIST';
export const ERROR_COMPANY_ADMIN_LIST = 'ERROR_COMPANY_ADMIN_LIST';

export const INIT_SINGLE_ADMIN_REQUEST = 'INIT_SINGLE_ADMIN_REQUEST';
export const SET_SINGLE_ADMIN = 'SET_SINGLE_ADMIN';
export const ERROR_SINGLE_ADMIN = 'ERROR_SINGLE_ADMIN';

export function initCompanyAdminListRequest() {
  return { type: INIT_COMPANY_ADMIN_LIST_REQUEST };
}

export function setCompanyAdminList(data) {
  return { type: SET_COMPANY_ADMIN_LIST, payload: data };
}

export function errorCompanyAdminList(error) {
  return { type: ERROR_COMPANY_ADMIN_LIST, payload: error };
}

export function initSingleAdminRequest(id) {
  return { type: INIT_SINGLE_ADMIN_REQUEST, payload: id };
}

export function setSingleAdmin(data) {
  return { type: SET_SINGLE_ADMIN, payload: data };
}

export function errorSingleAdmin(error) {
  return { type: ERROR_SINGLE_ADMIN, payload: error };
}
